import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["combinations", "toggleCheckbox", "variantStockForm", "saveImage"]
  static values = { id: Number, originalPrice: Number, salePrice: Number, listingImages: Array }

  toggleForm() {
    const checkbox = this.toggleCheckboxTarget
    const form = this.variantStockFormTarget

    if (checkbox.checked) {
      form.style.display = "block"
    } else {
      form.style.display = "none"
    }
  }

  async updateCombinations() {
    const variantGroups = this.element.querySelectorAll('.variant-group');
    const selectedOptions = [];

    // Loop through each variant group
    variantGroups.forEach(variantGroup => {
      const options = [];

      // Loop through checkboxes within the variant group
      variantGroup.querySelectorAll('input[type="checkbox"]:checked').forEach(checkbox => {
        options.push({
          id: checkbox.value,
          name: checkbox.nextElementSibling.textContent.trim()
        });
      });

      // Add the selected options for the variant group
      selectedOptions.push(options);
    });

    // To show only selected options with data within them
    const compactedArray = selectedOptions.filter(subArray => subArray.length > 0);
    if (compactedArray.length > 0) {
      // Generate all possible combinations
      const combinations = this.generateCombinations(selectedOptions);
      const extractedValues = combinations.map(arrayOfObjects => {
        return arrayOfObjects.map(object => object.id);
      });
  
      // Include individual selected options
      if (combinations.length == 0) {
          this.renderNoCombinationsTable(compactedArray[0]);
          const arrayOfIds = compactedArray[0].map(obj => [obj.id]);
          await this.displayStockQuantities(arrayOfIds)
      } else {
        this.renderTable(combinations);
        await this.displayStockQuantities(extractedValues)
      }
    } else {
      this.combinationsTarget.innerHTML = null;
      console.log('No options selected')
    }
  }

  async displayStockQuantities(combinations) {
    let listingId = this.idValue
    const response = await fetch('/listing_variant_stocks', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ combinations: combinations, listing_id: listingId })
    });

    const data = await response.json();

    // Iterate over the returned stock quantities and populate the form fields
    data.forEach((stock, index) => {
      const combinationRow = this.combinationsTarget.querySelector(`tr:nth-child(${index + 1})`);
      if (combinationRow) {
        const imageInput = combinationRow.querySelector(`input[name="selected_image_id[${stock.variant_option_ids}]"]`);
        if (imageInput) {
          const imageId = stock.selected_image_id
          imageInput.value = imageId;
          const imageElement = combinationRow.querySelector('[data-variants-target="variantImage"]');
          this.displayImage(imageId, imageElement)
        }

        const stockInput = combinationRow.querySelector(`input[name="stock[${stock.variant_option_ids}]"]`);
        if (stockInput) {
          stockInput.value = stock.stock_quantity;
        }

        const priceInput = combinationRow.querySelector(`input[name="price[${stock.variant_option_ids}]"]`);
        if (priceInput) {
          priceInput.value = stock.price;
        }

        const salePriceInput = combinationRow.querySelector(`input[name="sale_price[${stock.variant_option_ids}]"]`);
        if (salePriceInput) {
          salePriceInput.value = stock.sale_price;
        }

        const percentageDiscountInput = combinationRow.querySelector(`input[name="percentage_discount[${stock.variant_option_ids}]"]`);
        if (percentageDiscountInput) {
          percentageDiscountInput.value = stock.percentage_discount;
        }
      }
    });
  }

  renderTable(combinations) {
    let tableBody = '';
    let price = Math.floor(this.originalPriceValue)
    let salePrice = this.salePriceValue || null
    // const checkbox = this.toggleCheckboxTarget

    
    if (combinations.length > 0) {
      // Render table for combinations
      tableBody = combinations.map((combination, index) => {
        const variantOptionIds = combination.map(option => option.id).join(',');
        // const isRequired = checkbox.checked ? 'required' : '';
        return `
          <tr data-controller="margin-calculator" data-variants-option-id="${variantOptionIds}">
            <td>${index + 1}</td>
            <td>
              <img src="/images/icons/cloud-upload.svg" class="img-thumbnail" style="max-width: 50px; cursor: pointer;" 
                data-action="click->variants#openImageModal" 
                data-variants-target="variantImage"
                data-option-id="${variantOptionIds}">
              <input type="hidden" name="selected_image_id[${variantOptionIds}]"
                     data-variants-target="selectedImageId">
              <input type="file" name="variant_image[${variantOptionIds}]" 
                     style="display: none;" 
                     data-variants-target="imageUpload">
            </td>
            <td>${combination.map(option => option.name).join(', ')}</td>
            <td><input type="number" name="stock[${variantOptionIds}]" class="form-control min-input-width" value=""></td>
            <td><input type="number" name="price[${variantOptionIds}]" class="form-control" value="${price}" data-margin-calculator-target="price" data-action="input->margin-calculator#handleInputField" data-input-field="price"></td>
            <td><input type="number" name="sale_price[${variantOptionIds}]" class="form-control" value="${salePrice}" data-margin-calculator-target="salePrice" data-action="input->margin-calculator#handleInputField" data-input-field="salePrice"></td>
            <td><input type="number" step="any" name="percentage_discount[${variantOptionIds}]" class="form-control min-input-width" value="" data-margin-calculator-target="percentageDiscount" data-action="input->margin-calculator#handleInputField" data-input-field="percentageDiscount"></td>
            <td></td>
          </tr>
        `;
      }).join('');
    } 
    this.combinationsTarget.innerHTML = tableBody;
    // tableBody.dispatchEvent(new Event('input', { bubbles: true })); // This is technical debt. Introduces an error, not sure what it breaks yet UPDATE: It breaks retrieving existing listing variant stock data.
  }

  renderNoCombinationsTable(combinations) {
    let tableBody = '';
    let price = Math.floor(this.originalPriceValue)
    let salePrice = this.salePriceValue || null
      // Render table for individual selected options
      tableBody = combinations.map((option, index) => {
        return `
          <tr data-controller="margin-calculator" data-variants-option-id="${option.id}">
            <td>${index + 1}</td>
            <td>
              <img src="/images/icons/cloud-upload.svg" class="img-thumbnail" style="max-width: 50px; cursor: pointer;" 
                data-action="click->variants#openImageModal" 
                data-variants-target="variantImage"
                data-option-id="${option.id}">
              <input type="hidden" name="selected_image_id[${option.id}]" 
                     data-variants-target="selectedImageId">
              <input type="file" name="variant_image[${option.id}]" 
                     style="display: none;" 
                     data-variants-target="imageUpload">
            </td>
            <td>${option.name}</td>
            <td><input type="number" name="stock[${option.id}]" class="form-control" value=""></td>
            <td><input type="number" name="price[${option.id}]" class="form-control" value="${price}" data-margin-calculator-target="price" data-action="input->margin-calculator#handleInputField" data-input-field="price"></td>
            <td><input type="number" name="sale_price[${option.id}]" class="form-control" value="${salePrice}" data-margin-calculator-target="salePrice" data-action="input->margin-calculator#handleInputField" data-input-field="salePrice"></td>
            <td><input type="number" step="any" name="percentage_discount[${option.id}]" class="form-control" value="" data-margin-calculator-target="percentageDiscount" data-action="input->margin-calculator#handleInputField" data-input-field="percentageDiscount"></td>
            <td></td>
          </tr>
        `;
      }).join('');
      this.combinationsTarget.innerHTML = tableBody;
  }

  openImageModal(event) {
    this.currentOptionId = event.currentTarget.dataset.optionId;
    const modal = new bootstrap.Modal(document.getElementById("imageModal"));
    
    // Reset modal state
    const selectedImageInput = document.querySelector(`input[name="modal_selected_image_id"][value=""]`);
    if (selectedImageInput) selectedImageInput.checked = true;
    const uploadInput = document.getElementById("modal_image_upload");
    uploadInput.value = "";
    const preview = document.getElementById("image_preview");
    preview.style.display = "none";
    preview.src = "";

    modal.show();
  }

  displayImage(id, imageElement) {
    const image = this.listingImagesValue.find((img) => img.id == id);
    if (image) {
      imageElement.src = image.url;
    }
  }

  saveImage() {
    const selectedImageId = document.querySelector('input[name="modal_selected_image_id"]:checked')?.value;
    const uploadInput = document.getElementById("modal_image_upload");
    const row = this.combinationsTarget.querySelector(`tr[data-variants-option-id="${this.currentOptionId}"]`);
    const imageElement = row.querySelector('[data-variants-target="variantImage"]');
    const selectedImageInput = row.querySelector('[data-variants-target="selectedImageId"]');
    const uploadInputField = row.querySelector('[data-variants-target="imageUpload"]');

    if (selectedImageId) {
      // Handle selected existing image
      const image = this.listingImagesValue.find((img) => img.id == selectedImageId);
      if (image) {
        imageElement.src = image.url;
        selectedImageInput.value = selectedImageId;
        uploadInputField.files = null; // Clear upload
      } else {
        imageElement.src = "/images/default-placeholder.png";
        selectedImageInput.value = "";
      }
    } else if (uploadInput.files.length > 0) {
      // Handle uploaded image
      const file = uploadInput.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        imageElement.src = e.target.result;
        // Copy file to hidden file input for form submission
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        uploadInputField.files = dataTransfer.files;
        selectedImageInput.value = ""; // Clear selected image
      };
      reader.readAsDataURL(file);
    } else {
      imageElement.src = "/images/default-placeholder.png";
      selectedImageInput.value = "";
      uploadInputField.files = null;
    }

        // Close modal using vanilla JavaScript
        const modal = document.getElementById("imageModal");
        modal.classList.remove("show");
        modal.style.display = "none";
        document.body.classList.remove("modal-open");
        const backdrop = document.querySelector(".modal-backdrop");
        if (backdrop) backdrop.remove();
  }
  

  generateCombinations(arrays) {
    // Filter out empty arrays
    arrays = arrays.filter(arr => arr.length > 0);
  
    const combine = (arrays, prefix = []) => {
      if (!arrays.length) return [prefix];
      const [first, ...rest] = arrays;
      return first.flatMap(option => combine(rest, prefix.concat(option)));
    };
  
    return combine(arrays);
  }

  async loadListingImages() {
    // Fetch listing images via AJAX (adjust URL as needed)
    try {
      const response = await fetch(`/listings/${this.idValue}/images`);
      this.listingImagesValue = await response.json();
    } catch (error) {
      console.error("Error loading listing images:", error);
    }
  }

  async connect() {
    this.currentOptionId = null; // Track the current option being edited
    await this.loadListingImages();
    this.updateCombinations()
    this.toggleForm()
  }
}
